<div class="row gx-5 gy-2 product-layout">

  <!-- Image Carousel -->
  <div class="col-12 col-lg-5 product-layout__gallery d-flex align-items-start justify-content-center">
    <ngb-carousel
      class="product-carousel w-100 pb-4"
      [activeId]="initialSlideId"
      [showNavigationArrows]="true"
      [showNavigationIndicators]="true"
      [interval]="0"
      (slid)="onSlid($event)">
      <ng-template *ngFor="let slide of slides" ngbSlide [id]="slide.id">
        <div class="product-carousel__slide position-relative w-100">
          <img 
            [src]="slide.src"
            [alt]="slide.alt"
            class="product-carousel__image w-100 h-100 object-fit-contain"
            [class.product-carousel__image--out-of-stock]="isSlideOutOfStock(slide)">
          <span
            *ngIf="isSlideOutOfStock(slide)"
            class="product-carousel__out-of-stock position-absolute top-50 start-50 translate-middle rounded-pill px-4 px-md-5 py-2 py-md-3 fs-2 fw-semibold lh-sm text-nowrap">
            Out of stock
          </span>
          <small 
            *ngIf="getDimensions(slide) as dimensions"
            class="position-absolute bottom-0 start-50 translate-middle-x p-2 p-md-3 text-muted text-nowrap">
            {{ dimensions }}
          </small>
        </div>
      </ng-template>
    </ngb-carousel>
  </div>

  <!-- Product Options -->
  <div class="col-12 col-lg-7 product-layout__options py-4">

    <div class="product-intro mb-4" *ngIf="showIntro">
      <h1 class="product-intro__title fs-2 mb-0">Choose your tag style for {{ petName }}</h1>
      <p class="product-intro__subtitle mt-2 mb-0" *ngIf="subtitle">{{ subtitle }}</p>
    </div>

    <fieldset [disabled]="locked">
      <!-- Quantity selector -->
      <div class="mb-4" *ngIf="showQuantitySelector">
        <label class="product-options__label d-block mb-2 fs-6 fw-bold">Quantity</label>
        <div class="product-options__qty d-flex align-items-center gap-3">
          <!-- Decrease quantity button -->
          <button
            class="product-options__qty-btn d-flex align-items-center justify-content-center rounded-circle"
            (click)="onQuantityChange(quantity - 1)"
            [disabled]="quantity <= 1">
            &#8722;
          </button>

          <!-- Quantity -->
          <span class="product-options__qty-value fw-semibold text-center">{{ quantity }}</span>

          <!-- Increase quantity button -->
          <button
            class="product-options__qty-btn d-flex align-items-center justify-content-center rounded-circle"
            (click)="onQuantityChange(quantity + 1)"
            [disabled]="quantity >= maxQuantity">
            &#43;
          </button>
        </div>
      </div>

      <!-- Single item options (quantity = 1) -->
      <ng-container *ngIf="!showAccordion">
        <!-- Free/paid badge for single item -->
        <div class="mb-3" *ngIf="!locked && showSingleItemBadge">
          <ng-container *ngTemplateOutlet="tagBadge; context: { $implicit: isTagIncluded(0) }"></ng-container>
        </div>
        <ng-container *ngTemplateOutlet="itemOptions; context: { $implicit: items[0] }"></ng-container>
      </ng-container>

      <!-- Accordion (quantity > 1) -->
      <div *ngIf="showAccordion" [closeOthers]="true" ngbAccordion class="product-options__accordion">
        <div *ngFor="let item of items; let i = index" ngbAccordionItem [id]="'panel-' + i" (shown)="onItemShown(i)">
          <div ngbAccordionHeader>
            <button ngbAccordionButton>
              <div class="product-options__accordion-header d-flex align-items-center justify-content-between w-100">
                <div class="d-flex align-items-center gap-3">
                  <span class="fw-semibold">Smart tag {{ i + 1 }}</span>
                  <ng-container *ngTemplateOutlet="tagBadge; context: { $implicit: isTagIncluded(i) }"></ng-container>
                  <span class="product-options__excerpt text-muted d-flex align-items-center">
                    {{ getAccordionHeaderText(item) }}
                    <span class="product-options__excerpt-color d-inline-block rounded-circle flex-shrink-0" [style.background-color]="getColorHex(item)"></span>
                    <fa-icon
                      *ngIf="isOutOfStock(item)"
                      [icon]="['fas', 'triangle-exclamation']"
                      class="product-options__out-of-stock-icon"
                      title="Out of stock"></fa-icon>
                  </span>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <small class="text-decoration-underline text-muted">edit</small>
                  <span class="product-options__action-divider"></span>
                  <small
                    class="product-options__remove text-decoration-underline text-muted"
                    [class.product-options__remove--disabled]="locked"
                    role="button"
                    (click)="removeItem(i, $event)">
                    remove
                  </small>
                </div>
              </div>
            </button>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <ng-container *ngTemplateOutlet="itemOptions; context: { $implicit: item }"></ng-container>
              </ng-template>
            </div>
          </div>
        </div>
      </div>

      <!-- Add smart tags for additional pets -->
      <div class="mt-3 mb-4">
        <button
          class="product-options__add-btn d-flex align-items-center gap-2 border-0 bg-transparent p-0 fs-6 fw-bold"
          (click)="onQuantityChange(quantity + 1)"
          [disabled]="quantity >= maxQuantity">
          <span class="product-options__add-icon d-flex align-items-center justify-content-center rounded-circle flex-shrink-0 fs-6 fw-bold">&#43;</span>
          Add smart tags for additional pets
        </button>
        <p class="small text-muted mt-1 mb-0">Only one smart tag can be registered per pet</p>
      </div>
    </fieldset>

    <!-- CTA block -->

    <!-- all-free: every tag is free -->
    <div *ngIf="!locked && ctaMode === 'all-free'" class="mt-2">
      <button 
        class="product-options__continue-btn btn ui-btn ui-btn--primary fw-semibold w-100"
        [disabled]="hasOutOfStockItem"
        (click)="onContinueFreeOnly()">
        Confirm choice - {{ quantity }} tag{{ quantity !== 1 ? 's' : '' }}
      </button>
    </div>

    <!-- mixed: some tags are free, some are paid -->
    <div *ngIf="!locked && ctaMode === 'mixed'" class="mt-2 product-options__cta-group d-flex flex-column">
      <p class="product-options__cta-hint mb-1">
        You have <strong>{{ freeCount }} free</strong> smart tag{{ freeCount !== 1 ? 's' : '' }} available.
        <ng-container *ngIf="paidCount === 1">Tag {{ quantity }} will be charged.</ng-container>
        <ng-container *ngIf="paidCount > 1">Tags {{ freeCount + 1 }}–{{ quantity }} will be charged.</ng-container>
      </p>
      <button
        class="product-options__continue-btn btn ui-btn ui-btn--primary fw-semibold w-100"
        [disabled]="hasOutOfStockItem"
        (click)="onContinueWithPayment()">
        Continue and pay <span class="fw-bold">{{ totalPaidPrice }}</span> for {{ paidCount }} extra tag{{ paidCount !== 1 ? 's' : '' }}
      </button>
      <button 
        class="product-options__continue-btn btn ui-btn ui-btn--outline-dark fw-semibold w-100"
        [disabled]="hasOutOfStockItem"
        (click)="onContinueFreeOnly()">
        Continue with {{ freeCount }} included tag{{ freeCount !== 1 ? 's' : '' }} only
      </button>
    </div>

    <!-- paid-only -->
    <div *ngIf="!locked && ctaMode === 'paid-only'" class="mt-2">
      <button 
        class="product-options__continue-btn btn ui-btn ui-btn--primary fw-semibold w-100"
        [disabled]="hasOutOfStockItem"
        (click)="onContinueWithPayment()">
        Continue and pay <span class="fw-bold">{{ totalPaidPrice }}</span> for the tag{{ quantity !== 1 ? 's' : '' }}
      </button>
    </div>

    <!-- Skip link -->
    <div *ngIf="skipCtaText" class="mt-3 text-center">
      <button
        type="button"
        class="btn btn-link btn-sm p-0 text-body"
        (click)="skipTags.emit()">
        {{ skipCtaText }}
      </button>
    </div>

  </div>
</div>

<!-- Badge template -->
<ng-template #tagBadge let-isIncluded>
  <span
    *ngIf="!locked"
    class="product-options__tag-badge d-inline-flex align-items-center rounded-pill flex-shrink-0 fw-semibold py-1 px-2"
    [class.product-options__tag-badge--included]="isIncluded"
    [class.product-options__tag-badge--payment-required]="!isIncluded">
    {{ isIncluded ? 'Included' : 'Payment required' }}
  </span>
</ng-template>

<!-- Item options template -->
<ng-template #itemOptions let-item>

  <!-- Tag style -->
  <div class="mb-4">
    <label class="product-options__label d-flex align-items-center gap-2 mb-2 fs-6 fw-bold">
      Tag Style
      <fa-icon
        [icon]="['fas', 'info-circle']"
        class="clickable-tag"
        role="img"
        tabindex="0"
        aria-label="About tag styles"
        ngbTooltip="The hook &amp; loop tag lies flat against your pet’s collar and is made from flexible silicone. It is anti-snag, making it a safe choice for any cats that like to climb trees."
        placement="top bottom"
      ></fa-icon>
    </label>
    <div class="d-flex align-items-center gap-2">
      <div class="product-options__pill-group d-inline-flex mw-100 rounded-pill">
        <button
          class="product-options__pill border-0 rounded-pill fs-6 fw-semibold lh-1 text-nowrap"
          [class.product-options__pill--active]="item.hook === SmartTagType.HookAndLoop"
          (click)="selectHook(item, SmartTagType.HookAndLoop)">
          {{ hookLabels[SmartTagType.HookAndLoop] }}
        </button>
        <button
          class="product-options__pill border-0 rounded-pill fs-6 fw-semibold lh-1 text-nowrap"
          [class.product-options__pill--active]="item.hook === SmartTagType.Circular"
          (click)="selectHook(item, SmartTagType.Circular)">
          {{ hookLabels[SmartTagType.Circular] }}
        </button>
      </div>
    </div>
  </div>

  <!-- Size -->
  <div class="mb-4">
    <label class="product-options__label d-block mb-2 fs-6 fw-bold">Size</label>
    <div class="product-options__pill-group d-inline-flex mw-100 rounded-pill">
      <button
        class="product-options__pill border-0 rounded-pill fs-6 fw-semibold lh-1"
        [class.product-options__pill--active]="item.size === SmartTagSize.Small"
        (click)="item.size = SmartTagSize.Small">
        S
      </button>
      <button
        class="product-options__pill border-0 rounded-pill fs-6 fw-semibold lh-1"
        [class.product-options__pill--active]="item.size === SmartTagSize.Medium"
        (click)="item.size = SmartTagSize.Medium">
        M
      </button>
    </div>
  </div>

  <!-- Color -->
  <div class="mb-4">
    <label class="product-options__label d-block mb-2 fs-6 fw-bold">Colour</label>
    <div class="d-flex gap-2">
      <button
        *ngFor="let color of colors"
        class="product-options__color rounded-circle border-0 p-0 flex-shrink-0"
        [class.product-options__color--active]="item.color === color"
        [class.product-options__color--out-of-stock]="isOutOfStock(item, color)"
        [style.background-color]="getColorHex(item, color)"
        [attr.aria-label]="getColorLabel(color)"
        (click)="selectColor(item, color)">
        <fa-icon
          *ngIf="item.color === color && isOutOfStock(item, color)"
          [icon]="['fas', 'triangle-exclamation']"
          class="fs-5"
          title="Out of stock"></fa-icon>
      </button>
    </div>
  </div>

</ng-template>
